import React, {
	useEffect,
	useState
} from 'react'

import {
	useDispatch,
	useSelector
} from 'react-redux'

import {
	BrowserRouter as Router,
	Switch,
	Route,
	Link,
	useRouteMatch,
	useParams
} from "react-router-dom"

import {
	getWeeklyCompliance,
	getMonthlyCompliance,
	getComplianceInRange,
	selectComplianceData,
	updateDateRange,
	selectCompliance,
	selectDisplayKeys
} from './complianceSlice'

import {slidingQueryComparision} from '../../util/util'

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import ComplianceCharts from './complianceCharts/ComplianceCharts'


import classes from './Drilldown.module.css'

const accountTotals = (data, accountTypeFilter) => {
	console.log(data, accountTypeFilter)
	if (accountTypeFilter === 'chain') {
		return `${data?.gym_ids?.length} gyms - ${data?.trainer_ids?.length} trainers - ${data?.client_ids?.length} clients`
	} else if (accountTypeFilter === 'gym' || accountTypeFilter === 'gyms') {
		return `${data?.trainer_ids?.length} trainers - ${data?.client_ids?.length} clients`
	} else if (accountTypeFilter === 'trainer' || accountTypeFilter === 'trainers') {
		return `${data?.client_ids?.length} clients`
	} else {
		return ''
	}
}

const Drilldown = props => {
	const dispatch = useDispatch()
	const accountTypeFilter = useSelector(state => state.compliance.filters.account.type)
	const status = useSelector(state => state.compliance.status)
	const data = useSelector(selectCompliance)
	const eventType = useSelector(state => state.compliance.filters.eventType)

	const [query,setQuery] = useState('')

	const displayKeys = useSelector(selectDisplayKeys)

	const sortedData = data.sort((a,b)=>(
		query === ''
		? 0
		: slidingQueryComparision(a.user_name,b.user_name,query)
	))

	console.log(displayKeys,sortedData)
	return (
		<>
			{(data.length&&Boolean(data[0].user_name))&&
				<Form.Control className="mb-4" placeholder="Search by name" value={query} onChange={e=>{
					setQuery(e.target.value)
				}}/>
			}
			<div className={displayKeys.length > 1 ? classes.ChartRows : classes.ChartGrid}>

				{
					status === "loading" ?
						<Spinner animation="border" variant="primary" role="status">
							<span className="sr-only">Loading...</span>
						</Spinner> :
						(data.length > 0 ?
							data.map(dat => (
								<div key={dat.account_id} className={classes.DataBlock}>
									<div className="d-flex align-items-center justify-content-center flex-wrap">
										{dat.profile_pic ? <img src={dat.profile_pic} style={{ objectFit: 'cover' }} /> : null}
										<div>
											<h3>{dat.user_name || "Account Summary"}</h3>
											<small className="text-white m-2 d-block text-center">
												{accountTotals(dat, accountTypeFilter)}
											</small>
										</div>
									</div>
									<ComplianceCharts
										displayKeys={displayKeys}
										data={dat.compliance} />
								</div>
							)) :
							"No Data")

				}

			</div>
		</>
	)
}


export default Drilldown